import React from 'react'

import { usePermissions } from '@/hooks/usePermissions'

import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { EditPencilButton, OverflowText } from '@/components/ui'
import { EditDeviceFieldsI } from '@/features/device-crud'
import { DeviceType } from '@/graphql/generated/schemas'

import { DeviceConfigurationT } from '../types/types'

interface DevicesMisconfiguredModalIProps {
  isOpen: boolean
  devices: DeviceConfigurationT[]
  onClose: () => void
  onEditDevice: (device: EditDeviceFieldsI) => void
}

export const DevicesMisconfiguredModal = ({
  isOpen,
  devices,
  onClose,
  onEditDevice,
}: DevicesMisconfiguredModalIProps) => {
  const { shouldEnableUpdateDevice } = usePermissions()

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset='slideInBottom'
      onClose={onClose}
      scrollBehavior='inside'
      size='xl'
    >
      <ModalOverlay />
      <ModalContent bg='white' color='black' py='6' rounded='20px'>
        <ModalCloseButton color='black' opacity={0.4} />

        <Box fontSize='20px' fontWeight={500} px='24px'>
          Doors misconfigured
        </Box>

        <ModalBody p='24px'>
          <Flex flexDir='column' gap='5px'>
            {devices.map((d) => (
              <Flex
                alignItems='center'
                border='1px solid #D5DCE4'
                borderRadius='10px'
                justifyContent='space-between'
                key={d.id}
                px='16px'
                py='8px'
              >
                <OverflowText fontSize='14px' maxW='60%' noOfLines={1}>
                  {d.name}
                </OverflowText>
                <Flex alignItems='center' gap='8px'>
                  <DeviceStatus isAssociated={d.isAssociated} />
                  <EditPencilButton
                    disabledTooltipLabel='You do not have permissions to edit this device'
                    isDisabled={!shouldEnableUpdateDevice}
                    isLoading={false}
                    onClick={() =>
                      onEditDevice({
                        id: d.id,
                        name: d.name,
                        floorId: d.floorId,
                        type: DeviceType.Door,
                      })
                    }
                    tooltipLabel='Edit Device'
                  />
                </Flex>
              </Flex>
            ))}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const STATUS_BG_COLOR = '#DDDDDD'
const STATUS_TEXT_COLOR = '#656565'

export const DeviceStatus = ({ isAssociated }: { isAssociated: boolean }) => {
  const deviceText = isAssociated
    ? 'Missing camera grid'
    : 'Missing device association'
  return (
    <Box
      bg={STATUS_BG_COLOR}
      border='1px solid'
      borderColor={STATUS_BG_COLOR}
      borderRadius='12px'
      color={STATUS_TEXT_COLOR}
      fontSize='12px'
      fontWeight={500}
      p='8px'
    >
      <Text noOfLines={1}>{deviceText}</Text>
    </Box>
  )
}
